import React from "react";
import CalendarCell from "./CalendarCell";

const CalendarRow = ({ timeSlot, visibleMembers, filteredLogs, members, selectedSlot, activeDate, onSelectSlot }) => (
  <div
    key={timeSlot}
    className="calendar-row"
    style={{ gridTemplateColumns: `100px repeat(${visibleMembers.length}, minmax(130px, 1fr))` }}
  >
    <div className="time-col">{timeSlot}</div>
    {visibleMembers.map(member => {
      const entries = filteredLogs.filter(
        l => l.member === member && l.start === timeSlot
      );
      const memberMeta = members.find(item => item.name === member) || { color: "#bfa58a" };
      const isSelected = !!selectedSlot
        && selectedSlot.time === timeSlot
        && selectedSlot.member === member
        && selectedSlot.date === activeDate;

      return (
        <CalendarCell
          key={member}
          entries={entries}
          memberColor={memberMeta.color}
          selected={isSelected}
          onCellClick={() => onSelectSlot({ date: activeDate, time: timeSlot, member })}
          onEntryClick={entry => onSelectSlot({ date: activeDate, time: timeSlot, member, entry })}
        />
      );
    })}
  </div>
);

export default CalendarRow;
